import { ArticleOutlined, LogoutOutlined, PeopleOutlined, PersonOutlined, SecurityOutlined, BuildOutlined, RuleOutlined, PasswordOutlined, WidgetsOutlined } from "@mui/icons-material";
import { Drawer, Box, List, ListItem, ListItemText, Divider, ListItemIcon, Typography } from "@mui/material";
import { FC } from "react";
import { useNavigate } from "react-router-dom";
import ROUTES from "../../../library/constants/routeConstants";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import { callLogout } from "../../slices/authSlice";
import { version } from '../../../version';
import './Sidebar.scss';
import variables from '../../../assets/styles/variables.module.scss';
import { assetMap } from "../../../library/util/assetMap";
import RssFeedIcon from '@mui/icons-material/RssFeed';
interface SidebarProps {
    menuOpen: boolean,
    setMenuOpen(value: boolean): void;
    setPasswordModalOpen(value: boolean): void;
    isAdmin: boolean;
}

const Sidebar: FC<SidebarProps> = ({
    menuOpen,
    setMenuOpen,
    setPasswordModalOpen,
    isAdmin
}) => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    
    const handleLogout = () => {
        dispatch(callLogout());
    }

    return <Drawer
        anchor="right"
        open={menuOpen}
        variant="temporary"
        onClose={() => setMenuOpen(false)}
        sx={{
            position: 'relative',
             '& .MuiDrawer-paper': {
                backgroundColor: process.env.REACT_APP_SKIN_NAME === 'atai' ? variables.color_on_background : variables.color_background_grey,
                backgroundImage: 'none'
            }, }}
        className="wrapper-drawer"
        >
            <Box
                sx={{ width: 270, paddingTop: '16px' }}
                role="presentation"
                onClick={() => setMenuOpen(false)}
                onKeyDown={() => setMenuOpen(false)}
                className="menu-wrapper"
            >
                <List>
                    <Divider textAlign="left">Profile</Divider>
                    <ListItem button key="Update Password" onClick={() => setPasswordModalOpen(true)}>
                        <ListItemIcon>
                            <PasswordOutlined />
                        </ListItemIcon>
                        <ListItemText primary="Update Password" />
                    </ListItem>
                    {isAdmin && <>
                        <Divider textAlign="left">Admin</Divider>
                        <ListItem button key="Data Sources" onClick={() => navigate(ROUTES.DATA_SOURCES)}>
                            <ListItemIcon>
                                <RssFeedIcon />
                            </ListItemIcon>
                            <ListItemText primary="Data Sources" />
                        </ListItem>
                        <ListItem button key="Users" onClick={() => navigate(ROUTES.USERS)}>
                            <ListItemIcon>
                                <PersonOutlined />
                            </ListItemIcon>
                            <ListItemText primary="Users" />
                        </ListItem>
                        <ListItem button key="Teams" onClick={() => navigate(ROUTES.TEAMS)}>
                            <ListItemIcon>
                                <PeopleOutlined />
                            </ListItemIcon>
                            <ListItemText primary="Teams" />
                        </ListItem>
                        <ListItem button key="Tenants" onClick={() => navigate(ROUTES.TENANTS)}>
                            <ListItemIcon>
                                <PeopleOutlined />
                            </ListItemIcon>
                            <ListItemText primary="Tenants" />
                        </ListItem>
                        <ListItem button key="Roles" onClick={() => navigate(ROUTES.ROLES)}>
                            <ListItemIcon>
                                <SecurityOutlined />
                            </ListItemIcon>
                            <ListItemText primary="Roles" />
                        </ListItem>
                    </>}
                    <Divider textAlign="left"/>
                    <ListItem button key="Logout" onClick={handleLogout}>
                        <ListItemIcon>
                            <LogoutOutlined />
                        </ListItemIcon>
                        <ListItemText primary="Logout" />
                    </ListItem>
                </List>
            </Box>
        <Typography sx={{position: 'absolute', bottom: '16px', right: '16px', textAlign: 'right', width: '100%'}}>(Version {version})</Typography>
    </Drawer>
}

export default Sidebar;